import { autoinject, Aurelia } from 'aurelia-framework';
import {WebApiService}  from "./web-api-service";

@autoinject()
export class SettingsService {

    constructor(private api: WebApiService) {
        api.get("Carriers", "GetSettings")
            .then((result) => {
                this.settings = JSON.parse(result.response);
            });
    }

    settings: {}

}